import { render, staticRenderFns } from "./HumanResourcesMatrixTableUser.vue?vue&type=template&id=88da3172"
import script from "./HumanResourcesMatrixTableUser.vue?vue&type=script&lang=js"
export * from "./HumanResourcesMatrixTableUser.vue?vue&type=script&lang=js"
import style0 from "./HumanResourcesMatrixTableUser.vue?vue&type=style&index=0&id=88da3172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports